var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 103.000000 108.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,108.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1067 c-3 -7 -4 -102 -3 -212 l3 -200 190 0 190 0 0 210 0 210 -188 3 c-147 2 -189 0 -192 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 1064 c-3 -8 -6 -100 -6 -204 0 -147 3 -190 14 -199 9 -8 69 -11 192 -9 l179 3 0 210 0 210 -186 3 c-164 2 -187 0 -193 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 424 c-13 -13 -8 -399 5 -412 14 -14 344 -17 366 -4 9 7 12 56 10 213 l-3 204 -186 3 c-102 1 -188 -1 -192 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 423 c-13 -12 -8 -398 5 -411 13 -13 331 -18 362 -6 14 5 16 34 16 215 l0 209 -188 0 c-104 0 -192 -3 -195 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.ec575bbde24a32d203a451027f1c6160.svg";
export { ForwardRef as ReactComponent };